import IdentityCardWidget from './IdentityCardWidget';
import AudioPlayerWidget from './AudioPlayerWidget';
import SocialsWidget from './SocialsWidget';
import RecentPostsWidget from './RecentPostsWidget';

/**
 * Maps a profile_widgets.widget_type to its render component.
 * To add a new widget: build the component, add it here with a label,
 * and it becomes available in the "Add Widget" picker in edit mode.
 */
export const WIDGET_REGISTRY = {
  identity_card: {
    label: 'Identity Card',
    component: IdentityCardWidget,
    removable: false, // mandatory — only its position is user-controlled
  },
  audio_player: {
    label: 'Audio Player',
    component: AudioPlayerWidget,
    removable: true,
  },
  socials: {
    label: 'Socials',
    component: SocialsWidget,
    removable: true,
  },
  recent_posts: {
    label: 'Recent Posts',
    component: RecentPostsWidget,
    removable: true,
  },
};

export const getWidgetDefinition = (widgetType) => WIDGET_REGISTRY[widgetType] || null;
